import requestStatuses from '@cinch/oxd-utils/request-status/src'
import { createSelector } from 'reselect'
import { ProfileReducer } from '../reducers/domain'

const getProfileDownloadStatus = (state: { profile: ProfileReducer }) => state.profile.downloadStatus || ''
const statusEqualsProcessing = (downloadStatus: string) => downloadStatus === requestStatuses.PENDING

export default createSelector(getProfileDownloadStatus, statusEqualsProcessing)
